export const SET_FILTER_SUGGESTIONS_FOR_COUNTRY_REQUEST =
  'SET_FILTER_SUGGESTIONS_FOR_COUNTRY_REQUEST'

export const SET_FILTER_SUGGESTIONS_FOR_COUNTRY_SUCCESS =
  'SET_FILTER_SUGGESTIONS_FOR_COUNTRY_SUCCESS'
